export default "__VITE_ASSET__96a56b06__"